import apiClient from '@/modules/shared/services/apiClient';
import { ApiResponse } from '@/modules/shared/types';

export interface EntityLookupResult {
  entityId: string;
  entityCode: string;
  displayText: string;
  entityType: string;
  parentEntityId?: string;
  status?: string;
  metadata?: Record<string, string>;
}

export interface EntityLookupPagedResult {
  items: EntityLookupResult[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface EntityHierarchy {
  programId: string;
  programName?: string;
  hospitalId?: string;
  hospitalName?: string;
  hospitalCode?: string;
  hcpId?: string;
  hcpName?: string;
  hcpCode?: string;
  patientId?: string;
  patientName?: string;
  patientCode?: string;
  caseId?: string;
  caseNumber?: string;
}

export interface EntityLookupParams {
  search?: string;
  parentEntityId?: string;
  status?: string;
  roleName?: string;
  page?: number;
  pageSize?: number;
}

export const entityLookupService = {
  async searchEntities(
    programId: string,
    entityType: string,
    params: EntityLookupParams = {}
  ): Promise<ApiResponse<EntityLookupPagedResult>> {
    const response = await apiClient.get<ApiResponse<EntityLookupPagedResult>>(
      `/programs/${programId}/entity-lookup/${entityType}`,
      { params }
    );
    return response.data;
  },

  async getEntityById(
    programId: string,
    entityType: string,
    entityId: string
  ): Promise<ApiResponse<EntityLookupResult>> {
    const response = await apiClient.get<ApiResponse<EntityLookupResult>>(
      `/programs/${programId}/entity-lookup/${entityType}/${entityId}`
    );
    return response.data;
  },

  async resolveHierarchy(
    programId: string,
    entityType: string,
    entityId: string
  ): Promise<ApiResponse<EntityHierarchy>> {
    const response = await apiClient.get<ApiResponse<EntityHierarchy>>(
      `/programs/${programId}/entity-lookup/${entityType}/${entityId}/hierarchy`
    );
    return response.data;
  },
};
